import { DATE_OPTIONS } from "../../calendar-common/constants/dateOptions";
import { getOrdinalDay } from "../../calendar-common/helpers/formatDate";

export const getDateString = (date, culture) => {
    if (date === undefined || date === null) {
        return "";
    }

    var locale = culture.split("-")[0];
    var dateString = date.toLocaleDateString(locale, DATE_OPTIONS);

    if (locale !== "en") {
        return dateString;
    }

    const pr = new Intl.PluralRules(locale, { type: "ordinal" });
    const day = getOrdinalDay(pr.select(date.getDate()));

    var splitted = dateString.split(",");
    splitted[1] += day;
    dateString = splitted.join(",");

    return dateString;
};

export const getDatePostString = (date) => {
    if (date === undefined || date === null) {
        return "";
    }

    var splittedDate = date.toString().split(" ");
    var splittedHours = splittedDate[4].split(":");
    var finalDate =
        splittedDate[1] +
        " " +
        splittedDate[2] +
        ", " +
        splittedHours[0] +
        ":" +
        splittedHours[1] +
        " GMT";

    return finalDate;
};

export const getDateRange = (dateRange, culture) => {
    var fromDateString = getDateString(dateRange.from, culture);
    var toDateString = getDateString(dateRange.to, culture);
    var from = new Date(dateRange.from);
    var to = new Date(dateRange.to);

    var fromString = from ? fromDateString : " ";
    var toDivider =
        (to && !from) ||
        (to && from && from.setHours(0, 0, 0, 0) != to.setHours(0, 0, 0, 0))
            ? " - "
            : "";
    var toString =
        (to && !from) ||
        (to && from && from.setHours(0, 0, 0, 0) != to.setHours(0, 0, 0, 0))
            ? toDateString
            : "";

    return (
        <span>
            <span>{fromString}</span>
            <span>{toDivider}</span>
            <span>{toString}</span>
        </span>
    );
};
